export const environment = {
  production: true,
  apiUrl: "https://umyolgbtq.site/api_umyocards/public/api/"
};


